import React from "react";

export const AnalyticsHeader = () => {
  return (
    <div className="flex items-center justify-between">
      <h1 className="text-3xl font-bold">Analytics Dashboard</h1>
      <div className="text-sm text-muted-foreground">
        Last updated: {new Date().toLocaleString()}
      </div>
    </div>
  );
};